module.exports = __webpack_public_path__ + "img/mail.11100226.svg";